import React from 'react';
import { useParams } from 'react-router-dom';
import {
    VerticalFlex,
    HorizontalFlex,
    PadContainer,
    InfoAlert,
    HighlightedSection,
    Title,
} from 'smartsuite-ui';
import { DateTimeFormatter } from 'brock-date-time/lib/DateTimeFormatter';
import BagDetailLink from './BagDetailLink';

export default function BagList(props) {
    const { locationId } = useParams();

    function renderBagListItem(bag) {
        if (!bag.lastSeenDevice) {
            return (
                <div className="bag-list-item">
                    Bag{' '}
                    <b>
                        <BagDetailLink bag={bag} />
                    </b>{' '}
                    was not seen
                </div>
            );
        }

        return (
            <div className="bag-list-item">
                Bag{' '}
                <b>
                    <BagDetailLink bag={bag} />
                </b>{' '}
                was last scanned by <b>{bag.lastSeenDevice}</b> at{' '}
                <b>{DateTimeFormatter.timeLocal(bag.lastSeenTimeLocal)}</b>
            </div>
        );
    }

    const locationSummary = props.locationSummaries?.find(
        (x) => x.id?.toString() === locationId?.toString()
    );

    if (!locationSummary) {
        return <InfoAlert>Choose a location</InfoAlert>;
    }

    return (
        <VerticalFlex cssClassModifiers={['is-full']}>
            <HighlightedSection>
                <PadContainer cssClassModifiers={['pad-medium']}>
                    <Title cssClassModifiers={['size-small']}>
                        {locationSummary.description}
                    </Title>
                </PadContainer>
            </HighlightedSection>
            <PadContainer cssClassModifiers={['pad-small']} />
            {locationSummary.bags.map(renderBagListItem)}
        </VerticalFlex>
    );
}
